module.exports = __webpack_public_path__ + "img/9788989571124.7c449946.jpg";